import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Compact currency, e.g. $1.2M / $3.4K / $123 — for large business figures. */
export function fmtCurrency(v) {
  if (!v && v !== 0) return '$0';
  if (v >= 1000000) return `$${(v / 1000000).toFixed(1)}M`;
  if (v >= 1000) return `$${(v / 1000).toFixed(1)}K`;
  return `$${Math.round(v).toLocaleString()}`;
}

/** Precise USD, e.g. $12.35 — for cost figures where exactness matters. */
export function fmtUSD(v, digits = 2) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '$0.00';
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
}

/** Thousands-separated integer, e.g. 1,234,567 — for token counts. */
export function fmtNumber(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '0';
  return Math.round(n).toLocaleString();
}

/** True only for the global admin (set out-of-band, not via the website). */
export const isSuperadmin = (u) => u?.role === 'superadmin';

/** True for tenant admins AND superadmins. Use this for tenant-level
 *  admin UI (team management, the Settings → Usage tab, etc.) so a
 *  superadmin logged into their own tenant still sees those features. */
export const isAtLeastAdmin = (u) => u?.role === 'admin' || u?.role === 'superadmin';
